import React from 'react';

import OnboardPane from '../../../OnboardPane';

const mobile =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/onboard/WeddingDetails2_mobile.jpg';
const tablet =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/onboard/WeddingDetails2_tablet.jpg';
const desktop =
  'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/onboard/WeddingDetails2_desktop.jpg';

const imgSrcs = {
  mobile,
  tablet,
  desktop,
  alt: '',
};

const GuestCount = (): JSX.Element => <OnboardPane imgSrcs={imgSrcs} />;

export default GuestCount;
